import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dynamic-table',
  templateUrl: './dynamic-table.component.html',
  styleUrls: ['./dynamic-table.component.less']
})
export class DynamicTableComponent implements OnInit, OnDestroy{

  constructor(public location: Router) {
  }

  @Input() dataSource: any[];
  @Input() tableTitle: string;
  
  public get props(): string[] {
    if(!this.dataSource || this.dataSource.length == 0) return [];
    else return Object.getOwnPropertyNames(this.dataSource[0]).filter(v => v != 'ReportNumber');
  }


  
  ngOnInit(): void {
  }
  
  ngOnDestroy(): void {

  }

  navToReport(reportNumber: number) {
    this.location.navigateByUrl("screenings/review/" + reportNumber);
  } 
}
